import angular from 'angular';

angular
    .module('indexfile')

    .factory('IndexFileService', [
        '$resource',
        '$cookies',
        'API_CONFIG',
        'XSRF_TOKEN',
        function ($resource, $cookies, API_CONFIG, XSRF_TOKEN) {
            var IndexFile = $resource(
                API_CONFIG.url + '/v1/index-file/:id',
                { id: '@id' },
                {
                    // Recherche suivant les critères
                    search: {
                        url: API_CONFIG.url + '/v1/index-file/search',
                        method: 'POST',
                        isArray: true,
                    },
                    // close index-file
                    close: {
                        url: API_CONFIG.url + '/v1/index-file/:id/close',
                        method: 'POST',
                    },
                }
            );

            IndexFile.getDownloadUrl = function () {
                const csrf = $cookies.get(XSRF_TOKEN);
                return API_CONFIG.url + '/v1/index-file/download?_csrf=' + csrf;
            };

            return IndexFile;
        },
    ]);
